type ClickmagickGoal = "a" | "e" | "s";

type ClickmagickPayload = {
  cmc_project?: string;
  cmc_goal: ClickmagickGoal;
  cmc_ref: string;
  cmc_amt?: number | string;
  cmc_firstname?: string;
  cmc_lastname?: string;
  cmc_email?: string;
};

type ClickmagickCmc = {
  cmc_project?: string;
  cmc_ref?: string;
  log?: (payload: ClickmagickPayload) => void;
};

declare global {
  interface Window {
    clickmagick_cmc?: ClickmagickCmc;
    setClickmagickRef?: (value: string) => void;
  }
}

function getClickmagickObject() {
  if (typeof window === "undefined") return null;
  if (!window.clickmagick_cmc) return null;
  return window.clickmagick_cmc;
}

export function setClickmagickRef(cmcRef: string) {
  if (!cmcRef) return;
  const cmc = getClickmagickObject();
  if (!cmc) return;

  cmc.cmc_ref = cmcRef;
  if (typeof window.setClickmagickRef === "function") {
    window.setClickmagickRef(cmcRef);
  }
}

export function trackClickmagick(payload: ClickmagickPayload) {
  const cmc = getClickmagickObject();
  if (!cmc || typeof cmc.log !== "function") return;

  cmc.log({
    ...payload,
    cmc_project: payload.cmc_project || cmc.cmc_project,
  });
}

export function toClickmagickDealSlug(value?: string | string[]) {
  if (!value) return "unknown_deal";
  const slug = Array.isArray(value) ? value[0] : value;
  return (slug || "unknown_deal").replace(/[^a-zA-Z0-9_-]/g, "_");
}

